import { logoCompleto } from "@kaizen/brand";
import Image from "next/image";
import Link from "next/link";

export default function Header() {
  return (
    <header className="w-full px-6 md:px-12 py-6 flex items-center justify-between max-w-6xl mx-auto">
      <Link href="/" className="block">
        <Image
          src={logoCompleto}
          alt="Kaizen Feedback"
          width={180}
          height={50}
          className="h-10 md:h-12 w-auto"
          priority
        />
      </Link>
      <nav className="flex items-center gap-6 text-base">
        <Link
          className="text-text-secondary hover:text-olive transition-colors"
          href="/contacto"
        >
          Contacto
        </Link>
        <Link
          className="rounded-full border border-olive text-olive px-5 py-2.5 hover:bg-olive hover:text-white transition-colors font-medium"
          href="/sign-in"
        >
          Acceder
        </Link>
      </nav>
    </header>
  );
}
